window.addEventListener('keyup', function (event) {
  if (event.key === '`') {
    console.log('debug-css');
    document.documentElement.classList.toggle('debug-css');
  }
});